export enum PeriodValues {
  days = 'days',
  months = 'months',
}
